import { screeningsApiClient } from 'src/api/config';
import Notifier from 'common/helpers/Notifier';
import { isHttpSuccess } from 'src/api/utils/httpStatus';

async function assignScreen(screenId, assign) {
  try {
    const response = await screeningsApiClient.patch(
      `screenings/${screenId}/assign`,
      { assign },
    );

    if (!response || !isHttpSuccess(response.status)) {
      Notifier.dispatch(
        400,
        'Screening cannot be assigned',
      );
      return false;
    }

    return true;
  } catch (error) {
    Notifier.handleErrors(error);
    return false;
  }
}

export default assignScreen;
